'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-archive.routes';

export class BulletinArchiveComponent {
  constructor(BulletinService, Auth, $state, Config) {
    'ngInject';

    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("bulletinArchive");

    this.isAdmin = Auth.isAdminSync;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, 'Bulletin Board Archive');

    this.bulletinsByRange = {
      "Q1-2017": [],
      "Q2-2017": [],
      "Q3-2017": [],
      "Q4-2017": [],

      "Q1-2016": [],
      "Q2-2016": [],
      "Q3-2016": [],
      "Q4-2016": [],

      "2015": [],
      "2014": [],
      "2013": [],
      "older": []
    };

    this.bulletins = [];

    BulletinService.queryArchive(data => {
      data.forEach(bulletin => {

        if (moment(bulletin.meta.creationDate).isBetween('2017-01-01', '2017-03-31')) {
          this.bulletinsByRange["Q1-2017"].push(bulletin);
        }
        else if (moment(bulletin.meta.creationDate).isBetween('2017-04-01', '2017-06-30')) {
          this.bulletinsByRange["Q2-2017"].push(bulletin);
        }
        else if (moment(bulletin.meta.creationDate).isBetween('2017-07-01', '2017-09-30')) {
          this.bulletinsByRange["Q3-2017"].push(bulletin);
        }
        else if (moment(bulletin.meta.creationDate).isBetween('2017-10-01', '2017-12-31')) {
          this.bulletinsByRange["Q4-2017"].push(bulletin);
        }
      })
    });

  }

  switchBulletinByRange(bulletinRange) {
    this.bulletins = this.bulletinsByRange[bulletinRange];
  }

  countBulletinByRange(bulletinRange) {
    return this.bulletinsByRange[bulletinRange].length;
  }
}

export default angular.module('conduuApp.bulletinArchive', [uiRouter])
  .config(routes)
  .component('bulletinArchive', {
    template: require('./bulletin-archive.html'),
    controller: BulletinArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/archive/bulletin-archive.component.js